import { I18n } from '@calendly/i18n';
import { IconFileExport } from '@calendly/ui/components/glyphs/IconFileExport';
import { IconButton } from '@calendly/ui/components/icon-button';
import { Tooltip } from '@calendly/ui/components/tooltip';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useSelector, useDispatch } from 'react-redux';
import { exportEvents } from 'actions/scheduled_events/export';
import FilterListAction from 'components/scheduled_events/filter_list/action';
import { AllSchedulingMethods } from 'constants/meetings';
import { useHomeTabs } from 'hooks/home/tabs';
import { useFilters } from 'hooks/meetings/filters';
import { timezoneSelector } from 'selectors/current_user';
import { useLookupUuidsQuery } from './api';
import { useUpcomingPreset } from './hooks/use_upcoming_preset';
import { mapMeetingsFilterParamsToExportParams, normalizeScheduledEventsExportScope } from './map_meetings_filter_params_to_export_params';
import { getPresetWeekRange } from './utils';
const exportButtonLabelCss = "esngpff";

/** Same scheduling_methods default as list search / useFilterParamsWithUuids. */
const filterDefaultsWithSchedulingMethods = filterDefaults => ({
  ...(filterDefaults || {}),
  scheduling_methods: filterDefaults?.scheduling_methods ?? AllSchedulingMethods
});
export const ExportButton = ({
  scope: scopeProp,
  text,
  filterDefaults,
  iconOnly = false
}) => {
  const dispatch = useDispatch();
  const isDisabled = useSelector(state => state.scheduled_events.export.loading);
  const {
    getTabScopeV2
  } = useHomeTabs();
  const {
    getFilterParams
  } = useFilters();
  // When the Upcoming preset is active the list is forward-only (today + upcoming, no past);
  // mirror that in the export so the CSV covers the same set instead of coercing to all_time.
  const {
    presetActive,
    presetFlagOn,
    presetPeriod
  } = useUpcomingPreset();
  const timezone = useSelector(timezoneSelector);
  const filterParams = getFilterParams(filterDefaultsWithSchedulingMethods(filterDefaults));
  const {
    data: lookupUuids
  } = useLookupUuidsQuery({
    filters: filterParams
  });
  const tabScope = getTabScopeV2();
  const exportScope = normalizeScheduledEventsExportScope(tabScope.type ?? scopeProp?.type, tabScope.id ?? scopeProp?.id);
  const handleExport = () => {
    const hydratedParams = lookupUuids ? {
      ...filterParams,
      ...lookupUuids
    } : filterParams;
    dispatch(exportEvents(mapMeetingsFilterParamsToExportParams(hydratedParams, {
      forwardOnly: presetFlagOn && presetActive,
      presetPeriod: presetFlagOn ? presetPeriod : null,
      // Week chips: export the dates on screen rather than a period name the server re-resolves.
      presetDateRange: presetFlagOn ? getPresetWeekRange(presetPeriod, timezone) : null
    }), exportScope));
  };
  const usePresetHeaderIcon = iconOnly || presetFlagOn && text == null;
  const exportLabel = usePresetHeaderIcon ? I18n.t('publisher.action.export') : I18n.t('publisher.meetings.export');
  if (usePresetHeaderIcon) {
    return <Tooltip placement="top" text={exportLabel}>
        <IconButton
      // Figma page-header trailing actions (3250:194468): IconButton medium (40px / 24px glyph).
      size="medium" icon={IconFileExport} onClick={handleExport} aria-disabled={isDisabled} disabled={isDisabled} aria-label={exportLabel} data-testid="meetings-export-button" />
      </Tooltip>;
  }
  return <FilterListAction decoration="minimal" isDisabled={isDisabled} onClick={handleExport}>
      <UiIcon icon={IconFileExport} size="small" />
      {text != null && <span className={exportButtonLabelCss}>
          {text}
        </span>}
    </FilterListAction>;
};

require("./export_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./export_button.js");